module.exports = require("classnames");


//////////////////
// WEBPACK FOOTER
// external {"root":"classNames","commonjs2":"classnames","commonjs":"classnames","amd":"classnames","umd":"classnames"}
// module id = 6
// module chunks = 0